(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ip-app-demo')) {
    customElements.define('ip-app-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-ip-app-play]')) {
            const player = this.querySelector('[data-ip-app-player]');
            if (!player.querySelector('video')) player.append(this.querySelector('[data-ip-app-template]').content.cloneNode(true));
            if (!dialog.open) dialog.showModal();
            const video = player.querySelector('video');
            if (video) video.play().catch(() => {});
          }
          if (event.target.closest('[data-ip-app-close]')) dialog.close();
          if (event.target === dialog) {
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          }
        }, { signal });
        dialog.addEventListener('close', () => {
          const video = dialog.querySelector('video');
          if (video) video.pause();
        }, { signal });
      }
      disconnectedCallback() {
        const video = this.querySelector('video');
        if (video) video.pause();
        if (this.controller) this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-smart-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    const input = event.target;
    if (!input.matches('.ip-swatch input')) return;
    const card = input.closest('[data-ip-card]');
    const image = card.querySelector('.ip-smart__image');
    if (input.dataset.image && image) { image.removeAttribute('srcset'); image.src = input.dataset.image; image.alt = input.dataset.alt || ''; image.classList.toggle('ip-smart__image--group', input.dataset.group === 'true'); }
    const label = card.querySelector('[data-color-label]');
    if (label) label.textContent = label.textContent.split(':')[0] + ': ' + input.value;
    const link = card.querySelector('[data-product-link]');
    if (link && input.dataset.url) link.href = input.dataset.url;
    const price = card.querySelector('[data-product-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;
  });
  document.addEventListener('click', function(event) {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) { const dialog = document.getElementById(opener.dataset.dialogOpen); if (dialog) dialog.showModal(); }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('.ip-dialog')) { const box = event.target.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close(); }
  });

  } catch(e) { console.error(e); }
})();
})();
